import type {
  MultiStoreCenterDates,
  MultiStoreCenterTimes,
  MultiStorePointOfSale,
  MultiStorePointOfSaleResponse,
  MultiStoreSlotDetailsResponse,
  MultiStoreSlotsResponse,
} from '../../interface/multi-store';
import { fromApiDate, toHourMinutes } from './dates';

// DTO -> PointOfSale con tutti i campi di contatto: dopo il cambio centro riepilogo,
// conferma e .ics leggono l'activePoint dello store
export const toMultiStorePointOfSale = (
  dto: MultiStorePointOfSaleResponse
): MultiStorePointOfSale => ({
  id: dto.id,
  name: dto.name ?? '',
  email: dto.email ?? undefined,
  telephone: dto.telephone ?? undefined,
  description: dto.description ?? undefined,
  address: dto.address ?? '',
  region: dto.region ?? undefined,
  city: dto.city ?? '',
  postalCode: dto.postalCode ?? undefined,
  fax: dto.fax ?? undefined,
  latitude: dto.latitude ?? undefined,
  longitude: dto.longitude ?? undefined,
  distance: dto.distance ?? undefined,
  isDistanceFromCustomer: dto.isDistanceFromCustomer,
});

const findCenter = <T extends { pointOfSaleId: string }>(
  pointOfSales: T[] | undefined,
  pointOfSaleId: string
): T | undefined =>
  (pointOfSales ?? []).find(
    (center) =>
      center.pointOfSaleId.toLowerCase() === pointOfSaleId.toLowerCase()
  );

// Si chiede un centro per chiamata: se manca nella risposta il backend lo ha scartato
// (non candidato) o omesso (motore slot in errore), quindi il centro non è disponibile
export const toCenterDates = (
  response: MultiStoreSlotsResponse | undefined,
  pointOfSaleId: string
): MultiStoreCenterDates | null => {
  const center = findCenter(response?.pointOfSales, pointOfSaleId);
  if (center === undefined) return null;
  return {
    pointOfSaleId,
    isAnyUser: center.isAnyUser,
    dates: center.dates.map(fromApiDate),
  };
};

export const toCenterTimes = (
  response: MultiStoreSlotDetailsResponse | undefined,
  pointOfSaleId: string
): MultiStoreCenterTimes | null => {
  const center = findCenter(response?.pointOfSales, pointOfSaleId);
  if (center === undefined) return null;
  return {
    pointOfSaleId,
    isAnyUser: center.isAnyUser,
    times: center.times.map(toHourMinutes),
  };
};
